import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Detail as DetailComponent, InfoHeader, useDrawer } from 'src/mtska-frontend-app-component';
import { useDataProvider } from 'src/mtska-frontend-data-provider';
import { AppContext } from 'src/mtska-frontend-app-scaffolding';

const dataProviderName = 'persons/person';
const wizardName = 'Service association';
const wizardObject = 'Service';
const wizardAction = 'serviceAssociation';

const ServiceAssociation = (params) => {
    const { t } = useTranslation();
    const { close } = useDrawer();
    const { userCapabilities, existingModules } = useContext(AppContext);


    // DATA PROVIDER
    const { 
        item, 
        errorMessage, 
        errors, 
        saving, 
        doAction,
    } = useDataProvider(dataProviderName, params.multipart);

    const modelName = existingModules.modelName

    const detailConfig = {
        "tabs": [
            {
                "name": "association",
                "fieldsets": [
                    {
                        "name": "association",
                        "fields": {
                            "available_services": {
                                "type": "sectiontitle",
                                "className":"col-12"
                            },
                            "associated": {
                                "type": "servicelist",
                                "relatedElements": {
                                    "assignedModel":"employee",
                                    "employment":() => { return {...item?.data?.employment, person:item?.data }} ,
                                    "legalEntity":item?.data?.legalEntity,
                                },
                                "defaultSelectedValues":[], 
                                "enableSelection":true, 
                                "disableMultipleRowSelection":true,
                                "dataProviderName":"cars/service",
                                "filters":{
                                    "items":[
                                        {
                                            "field":"employment_id",
                                            "operator":"isEmpty",
                                            "value":true
                                        },
                                        {
                                            "field":"car_id",
                                            "operator":"isEmpty",
                                            "value":true
                                        },
                                        {
                                            "field":"contract_id",
                                            "operator":"isEmpty",
                                            "value":true
                                        }
                                    ]
                                },
                                "className":"col-12",
                                "required": "true"
                            },
                        }
                    }
                ]
            }
        ],
        "validation": []
    }

    const [editing, setEditing] = useState(false)

        
    const handleSave = (data) => {
        doAction({action: wizardAction, model: dataProviderName, data: data}).then((data) => params.handleClose(params.uid, data.item.data)).catch(() => console.error('catch handleSave'));
    }

    return <>
        <DetailComponent
            values={{ "id" : item?.data?._id }}
            modelName={modelName}
            detailConfig={detailConfig}
            save={handleSave}
            saving={saving}
            errors={errors}
            errorMessage={errorMessage}
            title={t(wizardName)}
            canSave={userCapabilities && userCapabilities[dataProviderName+'.'+wizardAction.toLowerCase()]}
            header={
                <InfoHeader
                    view="wizard"
                    title={t('Associate Service')}
                    subtitle={t('Assign a {{wizardObject}} to {{firstname}} {{lastname}}', { wizardObject:wizardObject, firstname: item.data.firstname, lastname: item.data.lastname })}
                />
            }
            {...params}
        />
    </>
}

export default ServiceAssociation;


